var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmDialog',{attrs:{"value":_vm.value,"title":_vm.title,"icon":"star","confirm-text":"Got it","hide-cancel":""},on:{"input":function($event){return _vm.$emit('input', $event)},"confirm":function($event){return _vm.$emit('input', false)}}},[_vm._v(" "+_vm._s(_vm.body)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }